// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as LandingRouteRouteImport } from './routes/_landing/route'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppCheckoutRouteImport } from './routes/_app/checkout'
import { Route as AppDevResourcesRouteImport } from './routes/_app/dev-resources'
import { Route as AppEmployeesRouteImport } from './routes/_app/employees'
import { Route as AppJobsRouteImport } from './routes/_app/jobs'
import { Route as AppMarketRouteImport } from './routes/_app/market'
import { Route as AppOffersRouteImport } from './routes/_app/offers'
import { Route as AppOrgsRouteImport } from './routes/_app/orgs'
import { Route as AppReportRouteImport } from './routes/_app/report'
import { Route as AppTeamsRouteImport } from './routes/_app/teams'
import { Route as LandingIndexRouteImport } from './routes/_landing/index'
import { Route as LandingCookiesPolicyRouteImport } from './routes/_landing/cookies-policy'
import { Route as LandingDocsRouteImport } from './routes/_landing/docs'
import { Route as LandingPrivacyPolicyRouteImport } from './routes/_landing/privacy-policy'
import { Route as LandingProfessionalsRouteImport } from './routes/_landing/professionals'
import { Route as LandingTermsOfUseRouteImport } from './routes/_landing/terms-of-use'
import { Route as AppPublicBeginPasswordResetRouteImport } from './routes/_app/_public.begin-password-reset'
import { Route as AppPublicLoginRouteImport } from './routes/_app/_public.login'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account.index'
import { Route as AppAccountApiRouteImport } from './routes/_app/account.api'
import { Route as AppAccountBillingRouteImport } from './routes/_app/account.billing'
import { Route as AppBetaGenerateRouteImport } from './routes/_app/beta.generate'
import { Route as AppDevResourcesIndexRouteImport } from './routes/_app/dev-resources.index'
import { Route as AppDevResourcesComponentsRouteImport } from './routes/_app/dev-resources.components'
import { Route as AppDevResourcesEmailsRouteImport } from './routes/_app/dev-resources.emails'
import { Route as AppDevResourcesErrorsRouteImport } from './routes/_app/dev-resources.errors'
import { Route as AppDevResourcesTransitionsRouteImport } from './routes/_app/dev-resources.transitions'
import { Route as AppEmployeesIndexRouteImport } from './routes/_app/employees.index'
import { Route as AppEmployeesEmployeeIdRouteImport } from './routes/_app/employees.$employeeId'
import { Route as AppJobsIndexRouteImport } from './routes/_app/jobs.index'
import { Route as AppJobsJobIdRouteImport } from './routes/_app/jobs.$jobId'
import { Route as AppOffersIndexRouteImport } from './routes/_app/offers.index'
import { Route as AppOffersOfferIdRouteImport } from './routes/_app/offers.$offerId'
import { Route as AppOrgsIndexRouteImport } from './routes/_app/orgs.index'
import { Route as AppRegisterIndexRouteImport } from './routes/_app/register.index'
import { Route as AppRegisterApplicantRouteImport } from './routes/_app/register.applicant'
import { Route as AppRegisterCompanyRouteImport } from './routes/_app/register.company'
import { Route as AppTeamsIndexRouteImport } from './routes/_app/teams.index'
import { Route as AppTeamsTeamIdRouteImport } from './routes/_app/teams.$teamId'
import { Route as AppTestIndexRouteImport } from './routes/_app/test.index'
import { Route as AppTestCompetencesRouteImport } from './routes/_app/test.competences'
import { Route as AppTestPersonalityRouteImport } from './routes/_app/test.personality'
import { Route as AppTestValuesRouteImport } from './routes/_app/test.values'
import { Route as AppPublicEmployeeInvitationTokenRouteImport } from './routes/_app/_public.employee-invitation.$token'
import { Route as AppPublicUpdatePasswordTokenRouteImport } from './routes/_app/_public.update-password.$token'
import { Route as AppPublicVerifyEmailTokenRouteImport } from './routes/_app/_public.verify-email.$token'
import { Route as AppAccountApiIndexRouteImport } from './routes/_app/account.api.index'
import { Route as AppAccountApiAppIdRouteImport } from './routes/_app/account.api.$appId'
import { Route as AppDevResourcesTransitionsIndexRouteImport } from './routes/_app/dev-resources.transitions.index'
import { Route as AppDevResourcesTransitionsOneRouteImport } from './routes/_app/dev-resources.transitions.one'
import { Route as AppDevResourcesTransitionsTwoRouteImport } from './routes/_app/dev-resources.transitions.two'
import { Route as AppEmployeesEmployeeIdReportRouteImport } from './routes/_app/employees.$employeeId.report'
import { Route as AppJobsJobIdIndexRouteImport } from './routes/_app/jobs.$jobId.index'
import { Route as AppJobsJobIdBoardRouteImport } from './routes/_app/jobs.$jobId.board'
import { Route as AppJobsJobIdDistributionRouteImport } from './routes/_app/jobs.$jobId.distribution'
import { Route as AppJobsJobIdReportRouteImport } from './routes/_app/jobs.$jobId.report'
import { Route as AppOffersOfferIdIndexRouteImport } from './routes/_app/offers.$offerId.index'
import { Route as AppOffersOfferIdBoardRouteImport } from './routes/_app/offers.$offerId.board'
import { Route as AppOffersOfferIdDistributionRouteImport } from './routes/_app/offers.$offerId.distribution'
import { Route as AppOffersOfferIdReportRouteImport } from './routes/_app/offers.$offerId.report'
import { Route as AppOrgsOrgIdIndexRouteImport } from './routes/_app/orgs.$orgId.index'
import { Route as AppTeamsTeamIdIndexRouteImport } from './routes/_app/teams.$teamId.index'
import { Route as AppTeamsTeamIdBoardRouteImport } from './routes/_app/teams.$teamId.board'
import { Route as AppTeamsTeamIdDistributionRouteImport } from './routes/_app/teams.$teamId.distribution'
import { Route as AppTeamsTeamIdEvaluateRouteImport } from './routes/_app/teams.$teamId.evaluate'
import { Route as AppTeamsTeamIdEvaluationRouteImport } from './routes/_app/teams.$teamId.evaluation'
import { Route as AppTeamsTeamIdReportRouteImport } from './routes/_app/teams.$teamId.report'
import { Route as AppAccountApiAppIdIndexRouteImport } from './routes/_app/account.api.$appId.index'
import { Route as AppAccountApiAppIdApplicantsRouteImport } from './routes/_app/account.api.$appId.applicants'
import { Route as AppAccountApiAppIdCompaniesRouteImport } from './routes/_app/account.api.$appId.companies'
import { Route as AppAccountApiAppIdJobsRouteImport } from './routes/_app/account.api.$appId.jobs'
import { Route as AppAccountApiAppIdPlaygroundRouteImport } from './routes/_app/account.api.$appId.playground'
import { Route as AppAccountApiAppIdSettingsRouteImport } from './routes/_app/account.api.$appId.settings'
import { Route as AppDevResourcesTransitionsOneIndexRouteImport } from './routes/_app/dev-resources.transitions.one.index'
import { Route as AppDevResourcesTransitionsOneItemRouteImport } from './routes/_app/dev-resources.transitions.one.item'
import { Route as AppOrgsOrgIdGroupsGroupIdRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId'
import { Route as AppOrgsOrgIdUsersGroupsRouteImport } from './routes/_app/orgs_.$orgId.users.groups'
import { Route as AppDevResourcesTransitionsOneItemIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.index'
import { Route as AppDevResourcesTransitionsOneItemAlphaRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha'
import { Route as AppDevResourcesTransitionsOneItemBoardRouteImport } from './routes/_app/dev-resources.transitions.one.item.board'
import { Route as AppDevResourcesTransitionsOneItemDeltaRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta'
import { Route as AppDevResourcesTransitionsOneItemGammaRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma'
import { Route as AppOrgsOrgIdGroupsGroupIdIndexRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.index'
import { Route as AppOrgsOrgIdGroupsGroupIdBoardRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.board'
import { Route as AppOrgsOrgIdGroupsGroupIdDistributionRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.distribution'
import { Route as AppOrgsOrgIdGroupsGroupIdReportRouteImport } from './routes/_app/orgs.$orgId.groups.$groupId.report'
import { Route as AppOrgsOrgIdUsersGroupsIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.index'
import { Route as AppDevResourcesTransitionsOneItemAlphaIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha.index'
import { Route as AppDevResourcesTransitionsOneItemAlphaXRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha.x'
import { Route as AppDevResourcesTransitionsOneItemAlphaYRouteImport } from './routes/_app/dev-resources.transitions.one.item.alpha.y'
import { Route as AppDevResourcesTransitionsOneItemDeltaIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta.index'
import { Route as AppDevResourcesTransitionsOneItemDeltaXRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta.x'
import { Route as AppDevResourcesTransitionsOneItemDeltaYRouteImport } from './routes/_app/dev-resources.transitions.one.item.delta.y'
import { Route as AppDevResourcesTransitionsOneItemGammaIndexRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma.index'
import { Route as AppDevResourcesTransitionsOneItemGammaXRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma.x'
import { Route as AppDevResourcesTransitionsOneItemGammaYRouteImport } from './routes/_app/dev-resources.transitions.one.item.gamma.y'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.index'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.describe.index'
import { Route as AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport } from './routes/_app/orgs_.$orgId.users.groups.$groupId.describe.$indicator.$step'

const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const LandingRouteRoute = LandingRouteRouteImport.update({
            id: '/_landing',getParentRoute: () => rootRouteImport
          })
const AppAccountRoute = AppAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRouteRoute
          })
const AppCheckoutRoute = AppCheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesRoute = AppDevResourcesRouteImport.update({
            id: '/dev-resources',path: '/dev-resources',getParentRoute: () => AppRouteRoute
          })
const AppEmployeesRoute = AppEmployeesRouteImport.update({
            id: '/employees',path: '/employees',getParentRoute: () => AppRouteRoute
          })
const AppJobsRoute = AppJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppRouteRoute
          })
const AppMarketRoute = AppMarketRouteImport.update({
            id: '/market',path: '/market',getParentRoute: () => AppRouteRoute
          })
const AppOffersRoute = AppOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => AppRouteRoute
          })
const AppOrgsRoute = AppOrgsRouteImport.update({
            id: '/orgs',path: '/orgs',getParentRoute: () => AppRouteRoute
          })
const AppReportRoute = AppReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppRouteRoute
          })
const AppTeamsRoute = AppTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => AppRouteRoute
          })
const LandingIndexRoute = LandingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LandingRouteRoute
          })
const LandingCookiesPolicyRoute = LandingCookiesPolicyRouteImport.update({
            id: '/cookies-policy',path: '/cookies-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingDocsRoute = LandingDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => LandingRouteRoute
          })
const LandingPrivacyPolicyRoute = LandingPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => LandingRouteRoute
          })
const LandingProfessionalsRoute = LandingProfessionalsRouteImport.update({
            id: '/professionals',path: '/professionals',getParentRoute: () => LandingRouteRoute
          })
const LandingTermsOfUseRoute = LandingTermsOfUseRouteImport.update({
            id: '/terms-of-use',path: '/terms-of-use',getParentRoute: () => LandingRouteRoute
          })
const AppPublicBeginPasswordResetRoute = AppPublicBeginPasswordResetRouteImport.update({
            id: '/_public/begin-password-reset',path: '/begin-password-reset',getParentRoute: () => AppRouteRoute
          })
const AppPublicLoginRoute = AppPublicLoginRouteImport.update({
            id: '/_public/login',path: '/login',getParentRoute: () => AppRouteRoute
          })
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountRoute
          })
const AppAccountApiRoute = AppAccountApiRouteImport.update({
            id: '/api',path: '/api',getParentRoute: () => AppAccountRoute
          })
const AppAccountBillingRoute = AppAccountBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AppAccountRoute
          })
const AppBetaGenerateRoute = AppBetaGenerateRouteImport.update({
            id: '/beta/generate',path: '/beta/generate',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesIndexRoute = AppDevResourcesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesComponentsRoute = AppDevResourcesComponentsRouteImport.update({
            id: '/components',path: '/components',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesEmailsRoute = AppDevResourcesEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesErrorsRoute = AppDevResourcesErrorsRouteImport.update({
            id: '/errors',path: '/errors',getParentRoute: () => AppDevResourcesRoute
          })
const AppDevResourcesTransitionsRoute = AppDevResourcesTransitionsRouteImport.update({
            id: '/transitions',path: '/transitions',getParentRoute: () => AppDevResourcesRoute
          })
const AppEmployeesIndexRoute = AppEmployeesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppEmployeesRoute
          })
const AppEmployeesEmployeeIdRoute = AppEmployeesEmployeeIdRouteImport.update({
            id: '/$employeeId',path: '/$employeeId',getParentRoute: () => AppEmployeesRoute
          })
const AppJobsIndexRoute = AppJobsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsRoute
          })
const AppJobsJobIdRoute = AppJobsJobIdRouteImport.update({
            id: '/$jobId',path: '/$jobId',getParentRoute: () => AppJobsRoute
          })
const AppOffersIndexRoute = AppOffersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersRoute
          })
const AppOffersOfferIdRoute = AppOffersOfferIdRouteImport.update({
            id: '/$offerId',path: '/$offerId',getParentRoute: () => AppOffersRoute
          })
const AppOrgsIndexRoute = AppOrgsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsRoute
          })
const AppRegisterIndexRoute = AppRegisterIndexRouteImport.update({
            id: '/register/',path: '/register/',getParentRoute: () => AppRouteRoute
          })
const AppRegisterApplicantRoute = AppRegisterApplicantRouteImport.update({
            id: '/register/applicant',path: '/register/applicant',getParentRoute: () => AppRouteRoute
          })
const AppRegisterCompanyRoute = AppRegisterCompanyRouteImport.update({
            id: '/register/company',path: '/register/company',getParentRoute: () => AppRouteRoute
          })
const AppTeamsIndexRoute = AppTeamsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsRoute
          })
const AppTeamsTeamIdRoute = AppTeamsTeamIdRouteImport.update({
            id: '/$teamId',path: '/$teamId',getParentRoute: () => AppTeamsRoute
          })
const AppTestIndexRoute = AppTestIndexRouteImport.update({
            id: '/test/',path: '/test/',getParentRoute: () => AppRouteRoute
          })
const AppTestCompetencesRoute = AppTestCompetencesRouteImport.update({
            id: '/test/competences',path: '/test/competences',getParentRoute: () => AppRouteRoute
          })
const AppTestPersonalityRoute = AppTestPersonalityRouteImport.update({
            id: '/test/personality',path: '/test/personality',getParentRoute: () => AppRouteRoute
          })
const AppTestValuesRoute = AppTestValuesRouteImport.update({
            id: '/test/values',path: '/test/values',getParentRoute: () => AppRouteRoute
          })
const AppPublicEmployeeInvitationTokenRoute = AppPublicEmployeeInvitationTokenRouteImport.update({
            id: '/_public/employee-invitation/$token',path: '/employee-invitation/$token',getParentRoute: () => AppRouteRoute
          })
const AppPublicUpdatePasswordTokenRoute = AppPublicUpdatePasswordTokenRouteImport.update({
            id: '/_public/update-password/$token',path: '/update-password/$token',getParentRoute: () => AppRouteRoute
          })
const AppPublicVerifyEmailTokenRoute = AppPublicVerifyEmailTokenRouteImport.update({
            id: '/_public/verify-email/$token',path: '/verify-email/$token',getParentRoute: () => AppRouteRoute
          })
const AppAccountApiIndexRoute = AppAccountApiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiRoute
          })
const AppAccountApiAppIdRoute = AppAccountApiAppIdRouteImport.update({
            id: '/$appId',path: '/$appId',getParentRoute: () => AppAccountApiRoute
          })
const AppDevResourcesTransitionsIndexRoute = AppDevResourcesTransitionsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsOneRoute = AppDevResourcesTransitionsOneRouteImport.update({
            id: '/one',path: '/one',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppDevResourcesTransitionsTwoRoute = AppDevResourcesTransitionsTwoRouteImport.update({
            id: '/two',path: '/two',getParentRoute: () => AppDevResourcesTransitionsRoute
          })
const AppEmployeesEmployeeIdReportRoute = AppEmployeesEmployeeIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppEmployeesEmployeeIdRoute
          })
const AppJobsJobIdIndexRoute = AppJobsJobIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppJobsJobIdRoute
          })
const AppJobsJobIdBoardRoute = AppJobsJobIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppJobsJobIdRoute
          })
const AppJobsJobIdDistributionRoute = AppJobsJobIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppJobsJobIdRoute
          })
const AppJobsJobIdReportRoute = AppJobsJobIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppJobsJobIdRoute
          })
const AppOffersOfferIdIndexRoute = AppOffersOfferIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOffersOfferIdBoardRoute = AppOffersOfferIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOffersOfferIdDistributionRoute = AppOffersOfferIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOffersOfferIdReportRoute = AppOffersOfferIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOffersOfferIdRoute
          })
const AppOrgsOrgIdIndexRoute = AppOrgsOrgIdIndexRouteImport.update({
            id: '/$orgId/',path: '/$orgId/',getParentRoute: () => AppOrgsRoute
          })
const AppTeamsTeamIdIndexRoute = AppTeamsTeamIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdBoardRoute = AppTeamsTeamIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdDistributionRoute = AppTeamsTeamIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluateRoute = AppTeamsTeamIdEvaluateRouteImport.update({
            id: '/evaluate',path: '/evaluate',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdEvaluationRoute = AppTeamsTeamIdEvaluationRouteImport.update({
            id: '/evaluation',path: '/evaluation',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppTeamsTeamIdReportRoute = AppTeamsTeamIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppTeamsTeamIdRoute
          })
const AppAccountApiAppIdIndexRoute = AppAccountApiAppIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdApplicantsRoute = AppAccountApiAppIdApplicantsRouteImport.update({
            id: '/applicants',path: '/applicants',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdCompaniesRoute = AppAccountApiAppIdCompaniesRouteImport.update({
            id: '/companies',path: '/companies',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdJobsRoute = AppAccountApiAppIdJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdPlaygroundRoute = AppAccountApiAppIdPlaygroundRouteImport.update({
            id: '/playground',path: '/playground',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppAccountApiAppIdSettingsRoute = AppAccountApiAppIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppAccountApiAppIdRoute
          })
const AppDevResourcesTransitionsOneIndexRoute = AppDevResourcesTransitionsOneIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneRoute
          })
const AppDevResourcesTransitionsOneItemRoute = AppDevResourcesTransitionsOneItemRouteImport.update({
            id: '/item',path: '/item',getParentRoute: () => AppDevResourcesTransitionsOneRoute
          })
const AppOrgsOrgIdGroupsGroupIdRoute = AppOrgsOrgIdGroupsGroupIdRouteImport.update({
            id: '/$orgId/groups/$groupId',path: '/$orgId/groups/$groupId',getParentRoute: () => AppOrgsRoute
          })
const AppOrgsOrgIdUsersGroupsRoute = AppOrgsOrgIdUsersGroupsRouteImport.update({
            id: '/orgs_/$orgId/users/groups',path: '/orgs/$orgId/users/groups',getParentRoute: () => AppRouteRoute
          })
const AppDevResourcesTransitionsOneItemIndexRoute = AppDevResourcesTransitionsOneItemIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemAlphaRoute = AppDevResourcesTransitionsOneItemAlphaRouteImport.update({
            id: '/alpha',path: '/alpha',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemBoardRoute = AppDevResourcesTransitionsOneItemBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemDeltaRoute = AppDevResourcesTransitionsOneItemDeltaRouteImport.update({
            id: '/delta',path: '/delta',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppDevResourcesTransitionsOneItemGammaRoute = AppDevResourcesTransitionsOneItemGammaRouteImport.update({
            id: '/gamma',path: '/gamma',getParentRoute: () => AppDevResourcesTransitionsOneItemRoute
          })
const AppOrgsOrgIdGroupsGroupIdIndexRoute = AppOrgsOrgIdGroupsGroupIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdBoardRoute = AppOrgsOrgIdGroupsGroupIdBoardRouteImport.update({
            id: '/board',path: '/board',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdDistributionRoute = AppOrgsOrgIdGroupsGroupIdDistributionRouteImport.update({
            id: '/distribution',path: '/distribution',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdGroupsGroupIdReportRoute = AppOrgsOrgIdGroupsGroupIdReportRouteImport.update({
            id: '/report',path: '/report',getParentRoute: () => AppOrgsOrgIdGroupsGroupIdRoute
          })
const AppOrgsOrgIdUsersGroupsIndexRoute = AppOrgsOrgIdUsersGroupsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppDevResourcesTransitionsOneItemAlphaIndexRoute = AppDevResourcesTransitionsOneItemAlphaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemAlphaRoute
          })
const AppDevResourcesTransitionsOneItemAlphaXRoute = AppDevResourcesTransitionsOneItemAlphaXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsOneItemAlphaRoute
          })
const AppDevResourcesTransitionsOneItemAlphaYRoute = AppDevResourcesTransitionsOneItemAlphaYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsOneItemAlphaRoute
          })
const AppDevResourcesTransitionsOneItemDeltaIndexRoute = AppDevResourcesTransitionsOneItemDeltaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemDeltaRoute
          })
const AppDevResourcesTransitionsOneItemDeltaXRoute = AppDevResourcesTransitionsOneItemDeltaXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsOneItemDeltaRoute
          })
const AppDevResourcesTransitionsOneItemDeltaYRoute = AppDevResourcesTransitionsOneItemDeltaYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsOneItemDeltaRoute
          })
const AppDevResourcesTransitionsOneItemGammaIndexRoute = AppDevResourcesTransitionsOneItemGammaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppDevResourcesTransitionsOneItemGammaRoute
          })
const AppDevResourcesTransitionsOneItemGammaXRoute = AppDevResourcesTransitionsOneItemGammaXRouteImport.update({
            id: '/x',path: '/x',getParentRoute: () => AppDevResourcesTransitionsOneItemGammaRoute
          })
const AppDevResourcesTransitionsOneItemGammaYRoute = AppDevResourcesTransitionsOneItemGammaYRouteImport.update({
            id: '/y',path: '/y',getParentRoute: () => AppDevResourcesTransitionsOneItemGammaRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdIndexRoute = AppOrgsOrgIdUsersGroupsGroupIdIndexRouteImport.update({
            id: '/$groupId/',path: '/$groupId/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute = AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRouteImport.update({
            id: '/$groupId/describe/',path: '/$groupId/describe/',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })
const AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute = AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRouteImport.update({
            id: '/$groupId/describe/$indicator/$step',path: '/$groupId/describe/$indicator/$step',getParentRoute: () => AppOrgsOrgIdUsersGroupsRoute
          })





const AppAccountApiAppIdRouteChildren = {
  AppAccountApiAppIdApplicantsRoute: AppAccountApiAppIdApplicantsRoute,AppAccountApiAppIdCompaniesRoute: AppAccountApiAppIdCompaniesRoute,AppAccountApiAppIdJobsRoute: AppAccountApiAppIdJobsRoute,AppAccountApiAppIdPlaygroundRoute: AppAccountApiAppIdPlaygroundRoute,AppAccountApiAppIdSettingsRoute: AppAccountApiAppIdSettingsRoute,AppAccountApiAppIdIndexRoute: AppAccountApiAppIdIndexRoute
}

const AppAccountApiAppIdRouteWithChildren = AppAccountApiAppIdRoute._addFileChildren(AppAccountApiAppIdRouteChildren)



const AppAccountApiRouteChildren = {
  AppAccountApiAppIdRoute: AppAccountApiAppIdRouteWithChildren,AppAccountApiIndexRoute: AppAccountApiIndexRoute
}

const AppAccountApiRouteWithChildren = AppAccountApiRoute._addFileChildren(AppAccountApiRouteChildren)



const AppAccountRouteChildren = {
  AppAccountApiRoute: AppAccountApiRouteWithChildren,AppAccountBillingRoute: AppAccountBillingRoute,AppAccountIndexRoute: AppAccountIndexRoute
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(AppAccountRouteChildren)




const AppDevResourcesTransitionsOneItemAlphaRouteChildren = {
  AppDevResourcesTransitionsOneItemAlphaXRoute: AppDevResourcesTransitionsOneItemAlphaXRoute,AppDevResourcesTransitionsOneItemAlphaYRoute: AppDevResourcesTransitionsOneItemAlphaYRoute,AppDevResourcesTransitionsOneItemAlphaIndexRoute: AppDevResourcesTransitionsOneItemAlphaIndexRoute
}

const AppDevResourcesTransitionsOneItemAlphaRouteWithChildren = AppDevResourcesTransitionsOneItemAlphaRoute._addFileChildren(AppDevResourcesTransitionsOneItemAlphaRouteChildren)




const AppDevResourcesTransitionsOneItemDeltaRouteChildren = {
  AppDevResourcesTransitionsOneItemDeltaXRoute: AppDevResourcesTransitionsOneItemDeltaXRoute,AppDevResourcesTransitionsOneItemDeltaYRoute: AppDevResourcesTransitionsOneItemDeltaYRoute,AppDevResourcesTransitionsOneItemDeltaIndexRoute: AppDevResourcesTransitionsOneItemDeltaIndexRoute
}

const AppDevResourcesTransitionsOneItemDeltaRouteWithChildren = AppDevResourcesTransitionsOneItemDeltaRoute._addFileChildren(AppDevResourcesTransitionsOneItemDeltaRouteChildren)




const AppDevResourcesTransitionsOneItemGammaRouteChildren = {
  AppDevResourcesTransitionsOneItemGammaXRoute: AppDevResourcesTransitionsOneItemGammaXRoute,AppDevResourcesTransitionsOneItemGammaYRoute: AppDevResourcesTransitionsOneItemGammaYRoute,AppDevResourcesTransitionsOneItemGammaIndexRoute: AppDevResourcesTransitionsOneItemGammaIndexRoute
}

const AppDevResourcesTransitionsOneItemGammaRouteWithChildren = AppDevResourcesTransitionsOneItemGammaRoute._addFileChildren(AppDevResourcesTransitionsOneItemGammaRouteChildren)



const AppDevResourcesTransitionsOneItemRouteChildren = {
  AppDevResourcesTransitionsOneItemAlphaRoute: AppDevResourcesTransitionsOneItemAlphaRouteWithChildren,AppDevResourcesTransitionsOneItemBoardRoute: AppDevResourcesTransitionsOneItemBoardRoute,AppDevResourcesTransitionsOneItemDeltaRoute: AppDevResourcesTransitionsOneItemDeltaRouteWithChildren,AppDevResourcesTransitionsOneItemGammaRoute: AppDevResourcesTransitionsOneItemGammaRouteWithChildren,AppDevResourcesTransitionsOneItemIndexRoute: AppDevResourcesTransitionsOneItemIndexRoute
}

const AppDevResourcesTransitionsOneItemRouteWithChildren = AppDevResourcesTransitionsOneItemRoute._addFileChildren(AppDevResourcesTransitionsOneItemRouteChildren)



const AppDevResourcesTransitionsOneRouteChildren = {
  AppDevResourcesTransitionsOneItemRoute: AppDevResourcesTransitionsOneItemRouteWithChildren,AppDevResourcesTransitionsOneIndexRoute: AppDevResourcesTransitionsOneIndexRoute
}

const AppDevResourcesTransitionsOneRouteWithChildren = AppDevResourcesTransitionsOneRoute._addFileChildren(AppDevResourcesTransitionsOneRouteChildren)



const AppDevResourcesTransitionsRouteChildren = {
  AppDevResourcesTransitionsOneRoute: AppDevResourcesTransitionsOneRouteWithChildren,AppDevResourcesTransitionsTwoRoute: AppDevResourcesTransitionsTwoRoute,AppDevResourcesTransitionsIndexRoute: AppDevResourcesTransitionsIndexRoute
}

const AppDevResourcesTransitionsRouteWithChildren = AppDevResourcesTransitionsRoute._addFileChildren(AppDevResourcesTransitionsRouteChildren)



const AppDevResourcesRouteChildren = {
  AppDevResourcesComponentsRoute: AppDevResourcesComponentsRoute,AppDevResourcesEmailsRoute: AppDevResourcesEmailsRoute,AppDevResourcesErrorsRoute: AppDevResourcesErrorsRoute,AppDevResourcesTransitionsRoute: AppDevResourcesTransitionsRouteWithChildren,AppDevResourcesIndexRoute: AppDevResourcesIndexRoute
}

const AppDevResourcesRouteWithChildren = AppDevResourcesRoute._addFileChildren(AppDevResourcesRouteChildren)




const AppEmployeesEmployeeIdRouteChildren = {
  AppEmployeesEmployeeIdReportRoute: AppEmployeesEmployeeIdReportRoute
}

const AppEmployeesEmployeeIdRouteWithChildren = AppEmployeesEmployeeIdRoute._addFileChildren(AppEmployeesEmployeeIdRouteChildren)



const AppEmployeesRouteChildren = {
  AppEmployeesEmployeeIdRoute: AppEmployeesEmployeeIdRouteWithChildren,AppEmployeesIndexRoute: AppEmployeesIndexRoute
}

const AppEmployeesRouteWithChildren = AppEmployeesRoute._addFileChildren(AppEmployeesRouteChildren)




const AppJobsJobIdRouteChildren = {
  AppJobsJobIdBoardRoute: AppJobsJobIdBoardRoute,AppJobsJobIdDistributionRoute: AppJobsJobIdDistributionRoute,AppJobsJobIdReportRoute: AppJobsJobIdReportRoute,AppJobsJobIdIndexRoute: AppJobsJobIdIndexRoute
}

const AppJobsJobIdRouteWithChildren = AppJobsJobIdRoute._addFileChildren(AppJobsJobIdRouteChildren)



const AppJobsRouteChildren = {
  AppJobsJobIdRoute: AppJobsJobIdRouteWithChildren,AppJobsIndexRoute: AppJobsIndexRoute
}

const AppJobsRouteWithChildren = AppJobsRoute._addFileChildren(AppJobsRouteChildren)




const AppOffersOfferIdRouteChildren = {
  AppOffersOfferIdBoardRoute: AppOffersOfferIdBoardRoute,AppOffersOfferIdDistributionRoute: AppOffersOfferIdDistributionRoute,AppOffersOfferIdReportRoute: AppOffersOfferIdReportRoute,AppOffersOfferIdIndexRoute: AppOffersOfferIdIndexRoute
}

const AppOffersOfferIdRouteWithChildren = AppOffersOfferIdRoute._addFileChildren(AppOffersOfferIdRouteChildren)



const AppOffersRouteChildren = {
  AppOffersOfferIdRoute: AppOffersOfferIdRouteWithChildren,AppOffersIndexRoute: AppOffersIndexRoute
}

const AppOffersRouteWithChildren = AppOffersRoute._addFileChildren(AppOffersRouteChildren)




const AppOrgsOrgIdGroupsGroupIdRouteChildren = {
  AppOrgsOrgIdGroupsGroupIdBoardRoute: AppOrgsOrgIdGroupsGroupIdBoardRoute,AppOrgsOrgIdGroupsGroupIdDistributionRoute: AppOrgsOrgIdGroupsGroupIdDistributionRoute,AppOrgsOrgIdGroupsGroupIdReportRoute: AppOrgsOrgIdGroupsGroupIdReportRoute,AppOrgsOrgIdGroupsGroupIdIndexRoute: AppOrgsOrgIdGroupsGroupIdIndexRoute
}

const AppOrgsOrgIdGroupsGroupIdRouteWithChildren = AppOrgsOrgIdGroupsGroupIdRoute._addFileChildren(AppOrgsOrgIdGroupsGroupIdRouteChildren)



const AppOrgsRouteChildren = {
  AppOrgsIndexRoute: AppOrgsIndexRoute,AppOrgsOrgIdIndexRoute: AppOrgsOrgIdIndexRoute,AppOrgsOrgIdGroupsGroupIdRoute: AppOrgsOrgIdGroupsGroupIdRouteWithChildren
}

const AppOrgsRouteWithChildren = AppOrgsRoute._addFileChildren(AppOrgsRouteChildren)




const AppTeamsTeamIdRouteChildren = {
  AppTeamsTeamIdBoardRoute: AppTeamsTeamIdBoardRoute,AppTeamsTeamIdDistributionRoute: AppTeamsTeamIdDistributionRoute,AppTeamsTeamIdEvaluateRoute: AppTeamsTeamIdEvaluateRoute,AppTeamsTeamIdEvaluationRoute: AppTeamsTeamIdEvaluationRoute,AppTeamsTeamIdReportRoute: AppTeamsTeamIdReportRoute,AppTeamsTeamIdIndexRoute: AppTeamsTeamIdIndexRoute
}

const AppTeamsTeamIdRouteWithChildren = AppTeamsTeamIdRoute._addFileChildren(AppTeamsTeamIdRouteChildren)



const AppTeamsRouteChildren = {
  AppTeamsTeamIdRoute: AppTeamsTeamIdRouteWithChildren,AppTeamsIndexRoute: AppTeamsIndexRoute
}

const AppTeamsRouteWithChildren = AppTeamsRoute._addFileChildren(AppTeamsRouteChildren)




const AppOrgsOrgIdUsersGroupsRouteChildren = {
  AppOrgsOrgIdUsersGroupsIndexRoute: AppOrgsOrgIdUsersGroupsIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdIndexRoute: AppOrgsOrgIdUsersGroupsGroupIdIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute: AppOrgsOrgIdUsersGroupsGroupIdDescribeIndexRoute,AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute: AppOrgsOrgIdUsersGroupsGroupIdDescribeIndicatorStepRoute
}

const AppOrgsOrgIdUsersGroupsRouteWithChildren = AppOrgsOrgIdUsersGroupsRoute._addFileChildren(AppOrgsOrgIdUsersGroupsRouteChildren)



const AppRouteRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,AppCheckoutRoute: AppCheckoutRoute,AppDevResourcesRoute: AppDevResourcesRouteWithChildren,AppEmployeesRoute: AppEmployeesRouteWithChildren,AppJobsRoute: AppJobsRouteWithChildren,AppMarketRoute: AppMarketRoute,AppOffersRoute: AppOffersRouteWithChildren,AppOrgsRoute: AppOrgsRouteWithChildren,AppReportRoute: AppReportRoute,AppTeamsRoute: AppTeamsRouteWithChildren,AppPublicBeginPasswordResetRoute: AppPublicBeginPasswordResetRoute,AppPublicLoginRoute: AppPublicLoginRoute,AppBetaGenerateRoute: AppBetaGenerateRoute,AppRegisterApplicantRoute: AppRegisterApplicantRoute,AppRegisterCompanyRoute: AppRegisterCompanyRoute,AppTestCompetencesRoute: AppTestCompetencesRoute,AppTestPersonalityRoute: AppTestPersonalityRoute,AppTestValuesRoute: AppTestValuesRoute,AppRegisterIndexRoute: AppRegisterIndexRoute,AppTestIndexRoute: AppTestIndexRoute,AppPublicEmployeeInvitationTokenRoute: AppPublicEmployeeInvitationTokenRoute,AppPublicUpdatePasswordTokenRoute: AppPublicUpdatePasswordTokenRoute,AppPublicVerifyEmailTokenRoute: AppPublicVerifyEmailTokenRoute,AppOrgsOrgIdUsersGroupsRoute: AppOrgsOrgIdUsersGroupsRouteWithChildren
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const LandingRouteRouteChildren = {
  LandingCookiesPolicyRoute: LandingCookiesPolicyRoute,LandingDocsRoute: LandingDocsRoute,LandingPrivacyPolicyRoute: LandingPrivacyPolicyRoute,LandingProfessionalsRoute: LandingProfessionalsRoute,LandingTermsOfUseRoute: LandingTermsOfUseRoute,LandingIndexRoute: LandingIndexRoute
}

const LandingRouteRouteWithChildren = LandingRouteRoute._addFileChildren(LandingRouteRouteChildren)

const rootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,LandingRouteRoute: LandingRouteRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)